import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// Shared Components
import { ButtonComponent } from '../components/button/button.component';
import { InputfieldComponent } from '../components/inputfield/inputfield.component';
import { FormErrorComponent } from '../components/form-error/form-error.component';
import { DynamicFormFieldComponent } from '../components/dynamic-form-field/dynamic-form-field.component';
import { PaymentTableComponent } from '../components/payment-table/payment-table.component';
import { FeatureBadgeComponent } from '../components/feature-badge/feature-badge.component';
import { AuditStatusComponent } from '../components/audit-status/audit-status.component';
import { HelpButtonComponent } from '../components/help-button/help-button.component';
import { GetAppComponent } from '../components/get-app/get-app.component';
import { PageHeaderComponent } from '../components/page-header/page-header.component';

// Material Module
import { MaterialModule } from './material.module';

const SHARED_COMPONENTS = [
  ButtonComponent,
  InputfieldComponent,
  FormErrorComponent,
  DynamicFormFieldComponent,
  PaymentTableComponent,
  FeatureBadgeComponent,
  AuditStatusComponent,
  HelpButtonComponent,
  GetAppComponent,
  PageHeaderComponent,
];

@NgModule({
  declarations: [
    ...SHARED_COMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
  ],
  exports: [
    // Re-export commonly used modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MaterialModule,
    // Export shared components
    ...SHARED_COMPONENTS,
  ],
})
export class SharedModule {}
